
import clsx from "clsx";
import React, { Component, createRef, Suspense } from "react";
import CountUp from 'react-countup';
import App from "../../App";
import { IGameManagerProps } from './IGameManagerProps';
import { TGameManagerState } from "./TGameManagerState";
import QuestionManager from "../QuestionsManager/QuestionManager";

import "./intro.scss";
import "./game.scss";
import "./hud_top.scss";
import "./labyrinthe.scss";
import "./hud_bas.scss";

import img_bouclier from "../../images/bouclier.svg";
import img_ecu from "../../images/ecu.svg";

import img_fleche_gauche from "../../images/fleche_gauche.svg";
import img_fleche_haut from "../../images/fleche_haut.svg";
import img_fleche_bas from "../../images/fleche_bas.svg";
import img_fleche_droite from "../../images/fleche_droite.svg";
import GameplayManager from "../GameplayManager/GameplayManager";
import { ICoffreHud, CodeQuestionListe, ICoffreHudEtat, CodeQuestions, IPopupType, IPopupQuestionBaseInfo } from '../../interfaces/ILabyData';

class GameManager extends Component<IGameManagerProps,TGameManagerState> {

  app:App;
  public questionManager:QuestionManager;

  state:TGameManagerState;
  getInitialState():TGameManagerState{
    const urlParams = this.app.urlParams;
    return{
      gameId:1,
      niveau:(urlParams.niveau ? parseInt(urlParams.niveau) : 0),
      ecus_niveau:(urlParams.ecus_niveau ? parseInt(urlParams.ecus_niveau) : 0),
      previous_ecus_niveau:(urlParams.ecus_niveau ? parseInt(urlParams.ecus_niveau) : 0),
      intro_active: true,
      infoplus_ouvert: false,
      game_active: false,
      popup_ouvert: false,
      question_ouverte: false,
      fin_partie_ouverte: false,
      windowActive: true,
      chronoActif: false,
      animationEnCours: false,
      directionsPermises:[],
      coffresHud:[],
      // Relatif à la question courante
      question_actuelle:undefined
    }
  }
  
  gameplayManager = createRef<GameplayManager>();

  contenuIntroDom = createRef<HTMLDivElement>();

  labyrintheDOM = createRef<HTMLDivElement>();
  wrapperLabDOM = createRef<HTMLDivElement>();
  jeuLabDOM = createRef<HTMLDivElement>();
  personnageDOM = createRef<HTMLImageElement>();
  
  constructor(props:IGameManagerProps){
    super(props);
    this.app = props.app;
    this.state = this.getInitialState();
    this.questionManager = new QuestionManager(this.app);
  }
  
  componentDidMount(){    
    window.addEventListener('focus', this.onWindowFocusIn); 
    window.addEventListener('blur', this.onWindowFocusOut); 
  }
  componentWillUnmount(){    
    window.removeEventListener('focus', this.onWindowFocusIn); 
    window.removeEventListener('blur', this.onWindowFocusOut); 
  }
  onWindowFocusIn = (event:FocusEvent) => {
    this.setState({windowActive:true});
  }
  onWindowFocusOut = (event:FocusEvent) => {
    this.setState({windowActive:false});
  }

  onIsLoaded(){    
    // On joue le son de silence deux fois pour que les deux players HTML aient été
    // utilisés au moins une fois chacun (contourne certains bug de "first play" sur certains navigateurs)     
    this.app.audioManager.current?.play("silence");
    this.app.audioManager.current?.play("silence");

    this.questionManager.init();
  }

  stopInitialAnimation(){
    
  }

  public retournerVersIntro(){
    this.setState({intro_active:true, game_active:false});
    this.app.footerRef?.setIntroActive(false);
    this.app.footerRef?.setGameActive(false);
    
    setTimeout(() => {
      this.contenuIntroDom.current?.scrollIntoView({behavior: "smooth"});
    }, 300);
  }

  public demarrerNouvellePartie(labyNiveau:number=0){
    const urlParams = this.app.urlParams;
    this.setState({
      gameId:(this.state.gameId + 1),
      niveau:labyNiveau,
      ecus_niveau:(urlParams.ecus_niveau ? parseInt(urlParams.ecus_niveau) : 0),
      previous_ecus_niveau:(urlParams.ecus_niveau ? parseInt(urlParams.ecus_niveau) : 0),
      intro_active:false,
      game_active:true,
      popup_ouvert: false,
      question_ouverte: false,
      fin_partie_ouverte: false,
      coffresHud:this.generateStartingCoffreHud(),
      animationEnCours: false,
      chronoActif:false
    });
    this.app.footerRef?.setIntroActive(false);
    this.app.footerRef?.setGameActive(true);
    this.app.footerRef?.setPopupOuvert(false);
    this.app.audioManager.current?.play("arrivee");
  }

  generateStartingCoffreHud():Array<ICoffreHud>{
    const arrayCoffres:Array<ICoffreHud> = [];
    for(var i=1; i<=15; i++){
      arrayCoffres.push(
        {
          code: CodeQuestionListe[i],
          etat: "closed",
          valeur:0
        }
      );
    }
    return arrayCoffres;
  }
  public updateCoffreHudStatus(coffreCode:CodeQuestions, newEtat:ICoffreHudEtat, valeur:number=0){
    const oldCoffreArray = [...this.state.coffresHud];
    const coffre = oldCoffreArray.filter(item => (item.code === coffreCode))[0];
    coffre.etat = newEtat;
    coffre.valeur = valeur;
    this.setState({coffresHud:oldCoffreArray});
  }

  handleInfoPlusClick(){
    var newVal = !this.state.infoplus_ouvert;    
    this.setState({infoplus_ouvert:newVal});
  }
  
  handleClickQuitter(){ 
    this.ouvrirPopup("quitter");
  }

  public ouvrirPopup(lequel:IPopupType=""){    
      this.app.popupManager.current?.openPopup(lequel);
  }
  public getIsWindowActive(){
    return this.state.windowActive;
  }
  public getIsPopupOuvert(){
    return this.state.popup_ouvert;
  }
  public getCurrentNiveau(){
    return this.state.niveau;
  }
  public onPopupOpen(lequel:IPopupType=""){
    this.setState({popup_ouvert:true});
    if (lequel === "question") this.setState({question_ouverte:true});
    if (lequel === "fin_partie") this.setState({fin_partie_ouverte:true});
    this.app.footerRef?.setPopupOuvert(true, lequel);
  }
  public onPopupClosed(lequel:IPopupType=""){
    this.setState({popup_ouvert:false});
    if (lequel === "question") this.setState({question_ouverte:false});
    if (lequel === "fin_partie") this.setState({fin_partie_ouverte:false});
    this.app.footerRef?.setPopupOuvert(false);
  }

  public ouvrirQuestion(codeQuestion:CodeQuestions, valeur:Number){
    // alert(`OUVRIR QUESTION ${codeQuestion} valeur ${valeur}`);    
    this.app.audioManager.current?.play("ouvrir_question");
    this.app.popupManager.current?.openPopup("question", ({valeur:valeur, code:codeQuestion} as IPopupQuestionBaseInfo));
  }
  public fermerQuestion(reussi:boolean, code:CodeQuestions, valeur:number){
    if (reussi){
      this.appliquerDeltaPointage(valeur);
      this.updateCoffreHudStatus(code, "opened", valeur);
    } else {
      this.updateCoffreHudStatus(code, "missed", valeur);
    }
    this.app.popupManager.current?.closePopup("question");
  }
  public ouvrirFinPartie(){
    // alert(`OUVRIR QUESTION ${codeQuestion} valeur ${valeur}`);
    this.app.popupManager.current?.openPopup("fin_partie", {valeur: this.state.ecus_niveau, niveau:this.state.niveau} );
  }

  handleClickChoixNiveau(niveauChoisi:number){
    this.demarrerNouvellePartie(niveauChoisi);
  }
  
  appliquerDeltaPointage(delta:number){
    var currentEcus = this.state.ecus_niveau;
    var newPreviousScore = currentEcus;
    var newCurrentScore = currentEcus + delta;
    this.setState({ecus_niveau:newCurrentScore, previous_ecus_niveau:newPreviousScore});
  }

  public setDirectionsPermises(ar:Array<string>){
    this.setState({directionsPermises:ar});
  }

  renderIntroPart(){
    return (
      <div className="intro">
        <div className="decorations">
          <div className="mur_du_haut"></div>          
          <div className="mur_du_bas"></div>
          <div className="muret_gauche"></div>
          <div className="muret_droit"></div>
          <div className="torche_gauche"></div>
          <div className="torche_droite"></div>
          <div className="coffre"></div>
          <div className="personnage"></div>
        </div>
        <div 
          className="contenu"
          ref={this.contenuIntroDom}
          dangerouslySetInnerHTML={{__html:(this.app.donneesLaby) ? this.app.donneesLaby.textes.popup_intro : "Texte manquant."}}
        />
        <div className={clsx("infoplus", this.state.infoplus_ouvert && "ouvert")}>
          <button className="toggle-infoplus" onClick={() => {this.handleInfoPlusClick();}}>Info {(this.state.infoplus_ouvert ? "-" : "+")}</button>
          <div className="infoplus-contenu" dangerouslySetInnerHTML={{__html:(this.app.donneesLaby) ? this.app.donneesLaby.textes.popup_intro_infoplus : "Texte manquant."}} />
        </div>
        <div className="choix_niveau">
          <h2>Choisissez un niveau.</h2>
          <div className="boutons_niveaux">
            <button onClick={() => {this.handleClickChoixNiveau(1)}}>1</button>
            <button onClick={() => {this.handleClickChoixNiveau(2)}}>2</button>
            <button onClick={() => {this.handleClickChoixNiveau(3)}}>3</button>
            <button onClick={() => {this.handleClickChoixNiveau(4)}}>4</button>
            <button onClick={() => {this.handleClickChoixNiveau(5)}}>5</button>
          </div>
        </div>
      </div>
    )
  }

  public renderCoffresHud(){
    const items = this.state.coffresHud;
    return (
      <>
        {items.map((item,index)=>{
          return (
            <div 
              key={`coffre_hud${index}`}
              className={clsx("coffre", `c_${item.code}`, (item.etat))} >
              <span className="nombre">{(item.valeur > 0) ? item.valeur : ""}</span>
              <span className="imgCoffre" />
            </div>)
        })}
      </>
    )
  }

  renderFlechesControl(){
    const getDisabledClass = (dir:string) =>{
      if (this.state.directionsPermises.indexOf(dir) === -1) return "disabled";
      return "";
    }
    return (
      <>
        <img className={clsx("gauche", getDisabledClass("GAUCHE"))} onClick={() => (this.gameplayManager.current?.handleClickFlecheHud("GAUCHE"))} src={img_fleche_gauche} alt="Aller à gauche" />
        <img className={clsx("haut", getDisabledClass("HAUT"))} onClick={() => (this.gameplayManager.current?.handleClickFlecheHud("HAUT"))} src={img_fleche_haut} alt="Aller en haut" />
        <img className={clsx("bas", getDisabledClass("BAS"))} onClick={() => (this.gameplayManager.current?.handleClickFlecheHud("BAS"))} src={img_fleche_bas} alt="Aller en bas" />
        <img className={clsx("droite", getDisabledClass("DROITE"))} onClick={() => (this.gameplayManager.current?.handleClickFlecheHud("DROITE"))} src={img_fleche_droite} alt="Aller à droite" />
      </>
    )
  }



  renderGameplayPart(){    
    return (
      <Suspense>
      <div className="gameplay">
        <div className="mur_du_haut"></div>       
        <div className="torche_gauche"></div>       
        <div className="torche_droite"></div>       
        <div className="hud top">
          <div className="wrapper">
            <div className="nbEcus mobile">
              <CountUp start={this.state.previous_ecus_niveau} end={this.state.ecus_niveau} duration={1.5}>
                {({ countUpRef }) => (
                  <span ref={countUpRef} />
                )}
              </CountUp>
              <img src={img_ecu} alt="Nombre d'écrus gagnés"/>
            </div>
            <span className="niveau">Niveau {this.state.niveau}</span>
            <button type="button" tabIndex={0} className="quitter" onClick={() => {this.handleClickQuitter();}}>
              <span className="texte">Quitter</span>
              <img src={img_bouclier} alt="Quitter"/>                
            </button>
          </div>
        </div>
        <GameplayManager 
          app={this.app}
          ref={this.gameplayManager}
          gameManager={this}
          niveau={this.state.niveau}  
        />
        <div className="hud bas">
          <div className="coffres">{this.renderCoffresHud()}</div>
          <div className="flechesControl">{this.renderFlechesControl()}</div>
          <div className="nbEcus pc">
              <CountUp start={this.state.previous_ecus_niveau} end={this.state.ecus_niveau} duration={1.5}>
                {({ countUpRef }) => (
                  <span ref={countUpRef} />
                )}
              </CountUp>
              <img src={img_ecu} alt="Nombre d'écrus gagnés"/>
          </div>
        </div>
      </div> 
      </Suspense>
    )
  }
  
  renderAppCurrentPart(){
    if (this.state.intro_active){
      return this.renderIntroPart();
    }
    return this.renderGameplayPart();
  }

  render() {      
    return (
        <div className={clsx("game_wrapper", 
        (this.state.popup_ouvert && "popup_ouvert"),
        (this.state.question_ouverte && "question_ouverte"),
        (this.state.fin_partie_ouverte && "fin_partie_ouverte"),
        (this.state.game_active && "playing"),
        (this.state.question_actuelle && "question"))}>
          {this.renderAppCurrentPart()}
        </div>
    )
  }
}

export default GameManager;